<template>
  <v-container class="mt-4 ml-2 pr-6" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-2">
            <div>
              <div class="text-subtitle-1">Direcciones Empleados</div>
              <div class="text-caption grey--text">
                Consulta de domicilios registrados en Trabajadores ERP
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-tabs
              v-model="tabActivos"
              color="primary"
              slider-color="primary"
              class="mb-4"
            >
              <v-tab>Activos</v-tab>
              <v-tab>Inactivos</v-tab>
            </v-tabs>

            <v-row align="center" class="mb-1">
              <v-col cols="12" md="5" lg="4">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  hint="Nombre, ID o domicilio"
                  persistent-hint
                  filled
                  dense
                  append-icon="mdi-magnify"
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="4">
                <div class="text-caption grey--text mb-1">Escuela</div>
                <v-btn-toggle
                  v-model="filtroEscuela"
                  mandatory
                  dense
                  color="primary"
                >
                  <v-btn small value="todos" class="text-capitalize">Todos</v-btn>
                  <v-btn small value="1" class="text-capitalize">INBI</v-btn>
                  <v-btn small value="2" class="text-capitalize">FAST</v-btn>
                </v-btn-toggle>
              </v-col>

              <v-col cols="12" md="3" lg="4">
                <v-chip
                  class="mt-4"
                  filter
                  outlined
                  :input-value="soloSinDomicilio"
                  :color="soloSinDomicilio ? 'orange darken-2' : 'grey'"
                  @click="soloSinDomicilio = !soloSinDomicilio"
                >
                  <v-icon left x-small>mdi-home-remove-outline</v-icon>
                  Sin domicilio
                </v-chip>
              </v-col>
            </v-row>

            <div class="d-flex align-center mt-4 mb-3">
              <span class="text-caption grey--text">
                {{ empleadosFiltrados.length }}
                {{ empleadosFiltrados.length === 1 ? 'empleado' : 'empleados' }}
              </span>
            </div>

            <v-row v-if="empleadosPagina.length">
              <v-col
                v-for="item in empleadosPagina"
                :key="item.id_trabajador"
                cols="12"
                sm="6"
                lg="4"
                xl="3"
              >
                <v-card
                  outlined
                  class="dir-card"
                  :class="{ 'dir-card--empty': !tieneDomicilio(item) }"
                  @click="abrirDetalle(item)"
                >
                  <div class="d-flex align-start">
                    <v-avatar size="40" color="primary" class="mr-3 flex-shrink-0">
                      <span class="white--text text-caption font-weight-medium">
                        {{ iniciales(item) }}
                      </span>
                    </v-avatar>
                    <div class="dir-card__body min-width-0">
                      <div class="dir-card__name text-subtitle-2">
                        {{ nombreEmpleado(item) }}
                      </div>
                      <div
                        v-if="tieneDomicilio(item)"
                        class="dir-card__address text-caption grey--text text--darken-1 mt-1"
                      >
                        <v-icon x-small color="primary" class="mr-1">mdi-map-marker-outline</v-icon>
                        {{ item.domicilio }}
                      </div>
                      <div v-else class="text-caption orange--text text--darken-2 mt-1">
                        Sin domicilio
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <div v-else-if="!cargar" class="dir-empty text-center py-12">
              <v-icon size="40" color="grey lighten-1">mdi-map-marker-off-outline</v-icon>
              <div class="text-subtitle-2 grey--text mt-3">
                No hay empleados con estos filtros
              </div>
            </div>

            <div
              v-if="empleadosFiltrados.length > itemsPerPage"
              class="d-flex justify-center mt-4"
            >
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="7"
                circle
                color="primary"
              ></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDetalle" max-width="640" scrollable>
      <v-card v-if="empleadoSeleccionado">
        <v-card-title class="text-subtitle-1 pb-1">
          {{ nombreEmpleado(empleadoSeleccionado) }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogDetalle = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-caption grey--text mb-1">Domicilio</div>
          <div class="text-body-2 mb-4">
            {{
              tieneDomicilio(empleadoSeleccionado)
                ? empleadoSeleccionado.domicilio
                : 'Sin domicilio registrado'
            }}
          </div>

          <template v-if="tieneDomicilio(empleadoSeleccionado)">
            <div v-if="mapaCargando" class="dir-map-placeholder">
              <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
              <span class="text-caption grey--text ml-3">Ubicando en el mapa…</span>
            </div>

            <template v-else-if="mapEmbedUrl">
              <iframe
                class="dir-map"
                :src="mapEmbedUrl"
                title="Mapa de domicilio"
                loading="lazy"
              ></iframe>
              <div class="d-flex flex-wrap align-center mt-2">
                <a
                  :href="mapExternalUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-caption primary--text"
                >
                  <v-icon x-small color="primary">mdi-open-in-new</v-icon>
                  {{ mapCoords ? 'Abrir en OpenStreetMap' : 'Abrir en Google Maps' }}
                </a>
                <span class="text-caption grey--text ml-3">
                  Ubicación aproximada
                </span>
              </div>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import { esAccesoDireccionesEmpleados } from '@/utils/permisosDireccionesEmpleados'

export default {
  name: 'DireccionesEmpleados',

  components: {
    Alerta,
    carga,
  },

  mixins: [validarErrores],

  data: () => ({
    tabActivos: 0,
    search: '',
    filtroEscuela: 'todos',
    soloSinDomicilio: false,
    empleados: [],
    page: 1,
    itemsPerPage: 24,
    dialogDetalle: false,
    empleadoSeleccionado: null,
    mapaCargando: false,
    mapCoords: null,
    geoCache: {},
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    activosLabel () {
      return this.tabActivos === 1 ? 'Inactivos' : 'Activos'
    },

    empleadosFiltrados () {
      const escuela = this.filtroEscuela
      const soloSin = this.soloSinDomicilio
      const tokens = this.tokensBusqueda()

      return this.empleados.filter((item) => {
        if (escuela === '1' && Number(item.escuela) !== 1) return false
        if (escuela === '2' && Number(item.escuela) !== 2) return false
        if (soloSin && this.tieneDomicilio(item)) return false
        if (!soloSin && !this.tieneDomicilio(item)) return false
        if (!tokens.length) return true
        return this.coincideBusqueda(item, tokens)
      })
    },

    pageCount () {
      return Math.max(1, Math.ceil(this.empleadosFiltrados.length / this.itemsPerPage))
    },

    empleadosPagina () {
      const inicio = (this.page - 1) * this.itemsPerPage
      return this.empleadosFiltrados.slice(inicio, inicio + this.itemsPerPage)
    },

    mapEmbedUrl () {
      if (this.mapCoords) {
        const lat = this.mapCoords.lat
        const lng = this.mapCoords.lng
        const delta = 0.012
        const bbox = (lng - delta) + '%2C' + (lat - delta) + '%2C' + (lng + delta) + '%2C' + (lat + delta)
        return 'https://www.openstreetmap.org/export/embed.html?bbox=' + bbox + '&layer=mapnik&marker=' + lat + '%2C' + lng
      }
      const domicilio = this.empleadoSeleccionado && this.empleadoSeleccionado.domicilio
      if (!domicilio) return ''
      return 'https://maps.google.com/maps?q=' + encodeURIComponent(domicilio) + '&hl=es&z=16&output=embed'
    },

    mapExternalUrl () {
      const domicilio = this.empleadoSeleccionado && this.empleadoSeleccionado.domicilio
      if (this.mapCoords) {
        const lat = this.mapCoords.lat
        const lng = this.mapCoords.lng
        return 'https://www.openstreetmap.org/?mlat=' + lat + '&mlon=' + lng + '#map=16/' + lat + '/' + lng
      }
      if (!domicilio) return '#'
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(domicilio)
    },
  },

  watch: {
    tabActivos () {
      this.page = 1
      this.initialize()
    },
    search () {
      this.page = 1
    },
    filtroEscuela () {
      this.page = 1
    },
    soloSinDomicilio () {
      this.page = 1
    },
    empleadosFiltrados () {
      if (this.page > this.pageCount) this.page = 1
    },
  },

  created () {
    if (!esAccesoDireccionesEmpleados(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)) {
      this.$router.replace({ name: 'Home' })
      return
    }
    this.initialize()
  },

  methods: {
    initialize () {
      this.cargar = true
      this.empleados = []
      const payload = { activos: this.activosLabel }

      return this.$http.post('trabajadores.erp.get.trabajadoreserp', payload).then((response) => {
        this.empleados = Array.isArray(response.data) ? response.data : []
      }).catch((error) => {
        const mensaje = error && error.body && error.body.message
          ? error.body.message
          : (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'No se pudieron cargar las direcciones'
        this.validarError(mensaje)
      }).finally(() => {
        this.cargar = false
      })
    },

    nombreEmpleado (item) {
      if (!item) return ''
      const completo = item.nombre_completo && String(item.nombre_completo).trim()
      if (completo) return completo
      return [item.nombres, item.apellido_paterno, item.apellido_materno]
        .filter(Boolean)
        .join(' ')
        .trim()
    },

    tieneDomicilio (item) {
      return !!(item && item.domicilio && String(item.domicilio).trim())
    },

    iniciales (item) {
      const nombre = this.nombreEmpleado(item)
      const partes = nombre.split(/\s+/).filter(Boolean)
      if (!partes.length) return '?'
      if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase()
      return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase()
    },

    normalizar (texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
    },

    tokensBusqueda () {
      return this.normalizar(this.search).split(/\s+/).filter(Boolean)
    },

    coincideBusqueda (item, tokens) {
      const haystack = this.normalizar([
        this.nombreEmpleado(item),
        item.nombres,
        item.apellido_paterno,
        item.apellido_materno,
        item.id_trabajador,
        item.domicilio,
        item.plantel,
        item.puesto,
        item.telefono1,
      ].join(' '))

      for (let i = 0; i < tokens.length; i++) {
        if (haystack.indexOf(tokens[i]) === -1) return false
      }
      return true
    },

    abrirDetalle (item) {
      this.empleadoSeleccionado = item
      this.mapCoords = null
      this.dialogDetalle = true

      if (!this.tieneDomicilio(item)) return

      this.mapaCargando = true
      this.geocodificar(item.domicilio).then((coords) => {
        this.mapCoords = coords
      }).finally(() => {
        this.mapaCargando = false
      })
    },

    expandirAbreviaturas (texto) {
      let t = String(texto || '')
      t = t.replace(/#/g, ' ')
      t = t.replace(/\bN[°º]\s*/gi, ' ')
      t = t.replace(/\bNUM(?:ERO)?\.?\s*/gi, ' ')
      t = t.replace(/\bNO\.\s*/gi, ' ')
      t = t.replace(/\bAV(?:E)?\.?\b/gi, 'Avenida')
      t = t.replace(/\bBLVD\.?\b/gi, 'Boulevard')
      t = t.replace(/\bFRACC?(?:IONAMIENTO)?\.?\b/gi, 'Fraccionamiento')
      t = t.replace(/\bCOL(?:ONIA)?\.?\b/gi, 'Colonia')
      t = t.replace(/\bPRIV\.?\b/gi, 'Privada')
      t = t.replace(/\bCDA\.?\b/gi, 'Cerrada')
      t = t.replace(/\bC\.\s+/gi, 'Calle ')
      t = t.replace(/\bCD\.?\b/gi, 'Ciudad')
      t = t.replace(/\bN\.?\s*L\.?\b/gi, 'Nuevo Leon')
      t = t.replace(/[.,;]+/g, ' ')
      t = t.replace(/\s+/g, ' ').trim()
      return t
    },

    elegirMejorPhoton (features) {
      const lista = Array.isArray(features) ? features : []
      const mx = lista.filter((f) => {
        const code = f && f.properties && String(f.properties.countrycode || '').toUpperCase()
        return code === 'MX'
      })
      const candidatos = mx.length ? mx : lista
      const tiposBuenos = { house: 3, street: 2, locality: 1, district: 1 }
      candidatos.sort((a, b) => {
        const ta = tiposBuenos[(a.properties && a.properties.type) || ''] || 0
        const tb = tiposBuenos[(b.properties && b.properties.type) || ''] || 0
        return tb - ta
      })
      const feat = candidatos[0]
      const coords = feat && feat.geometry && feat.geometry.coordinates
      if (!coords || coords.length < 2) return null
      return { lng: coords[0], lat: coords[1] }
    },

    consultarPhoton (consulta) {
      const url = 'https://photon.komoot.io/api/?limit=5&q=' + encodeURIComponent(consulta)
      return fetch(url).then((res) => {
        if (!res.ok) throw new Error('geocode')
        return res.json()
      }).then((data) => this.elegirMejorPhoton(data && data.features))
    },

    geocodificar (domicilio) {
      const key = this.normalizar(domicilio)
      if (Object.prototype.hasOwnProperty.call(this.geoCache, key)) {
        return Promise.resolve(this.geoCache[key])
      }

      const limpio = this.expandirAbreviaturas(domicilio)
      const consultas = [limpio + ' Mexico', limpio].filter((q, i, arr) => q && arr.indexOf(q) === i)

      const intentar = (indice) => {
        if (indice >= consultas.length) return Promise.resolve(null)
        return this.consultarPhoton(consultas[indice]).then((coords) => {
          if (coords) return coords
          return intentar(indice + 1)
        }).catch(() => intentar(indice + 1))
      }

      return intentar(0).then((coords) => {
        this.$set(this.geoCache, key, coords || null)
        return coords || null
      })
    },
  },
}
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.dir-card {
  height: 100%;
  border-radius: 10px !important;
  padding: 16px;
  cursor: pointer;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
}

.dir-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
  border-color: #90caf9 !important;
}

.dir-card--empty {
  background: #fafafa;
}

.dir-card__name {
  line-height: 1.3;
  color: #263238;
}

.dir-card__address {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.dir-map {
  width: 100%;
  height: 280px;
  border: 0;
  border-radius: 8px;
}

.dir-map-placeholder {
  height: 280px;
  border-radius: 8px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dir-empty {
  border: 1px dashed #e0e0e0;
  border-radius: 10px;
}
</style>
